import {
    CREATE_INACTIVESHARABLELINKS,
    RETRIEVE_INACTIVESHARABLELINKS,
    RETRIEVESINGLE_INACTIVESHARABLELINKS,
    UPDATE_INACTIVESHARABLELINKS,
    DELETE_INACTIVESHARABLELINKS,
  } from "../actions/type";
  const initialState = [];
  function InactiveSharableLinksReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_INACTIVESHARABLELINKS:
        return {data: state.data, payload};
      case RETRIEVE_INACTIVESHARABLELINKS:
        // console.log(payload)
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_INACTIVESHARABLELINKS:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_INACTIVESHARABLELINKS:
        return {data: state.data, payload};
      case DELETE_INACTIVESHARABLELINKS:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {InactiveSharableLinksReducer};